{
  "#LAGERKORREKTUR_ARTIKEL": {
    "APP": "Lagerkorrektur Artikel",
    "APP_DESC": "Mengenkorrektur (einseitige Lagerbuchung)",
    "TITLE": "Lagerkorrektur Artikel",
    "PAGES": {
      "LAGERPLATZ_SCANNEN": {
        "TITLE": "Lagerplatz scannen",
        "DESCRIPTION": "Bitte scannen Sie einen Lagerplatz-Barcode"
      },
      "ARTIKEL_AUSWAHL": {
        "TITLE": "Artikel auswählen",
        "DESCRIPTION": "Bitte Artikel auswählen",
        "LAGERPLATZ": "Lagerplatz",
        "ARTIKEL": "Artikel",
        "MENGE": "Menge",
        "CHANGE": "Ändern",
        "SUBMIT": "Weiter",
        "NO_ITEMS": "Auf diesem Lagerplatz sind keine Artikel vorhanden"
      },
      "MENGEN_AUSWAHL": {
        "TITLE": "Menge auswählen",
        "DESCRIPTION": "Bitte Menge auswählen",
        "LAGERPLATZ": "Lagerplatz",
        "ARTIKEL": "Artikel",
        "MENGE": "Menge",
        "CHANGE": "Ändern",
        "SUBMIT": "Weiter"
      },
      "UMBUCHUNGSARTIKEL_AUSWAHL": {
        "TITLE": "Umbuchungsartikel auswählen",
        "DESCRIPTION": "Bitte Umbuchungsartikel auswählen",
        "LAGERPLATZ": "Lagerplatz",
        "ARTIKEL": "Artikel",
        "MENGE": "Menge",
        "CHANGE": "Ändern",
        "UMBUCHUNGSARTIKEL": "Umbuchungsartikel",
        "SUBMIT": "Weiter"
      }
    },
    "MESSAGES": {
      "SUCCESS": {
        "KORREKTUR": "Der Artikel am Lagerplatz wurde korrigiert"
      },
      "ERROR": {
        "KOMMISSIONIERUNG_KEIN_ARTIKEL": "Der Artikel konnte nicht korrigiert werden, Es ist kein Artikel vorhanden"
      }
    }
  }
}
